const BASE = process.env.ENV === 'preview' ? 'api/gp-order-staging' : 'api/gp-order'
const urls = {
  /*
  * body
  *   tgId
  *   userId
  * */
  bindTgUser: 'get /api/order/investAdvisor/relateUserAndTgId',
  // 查询用户各账户余额
  getUserBalance: 'get /api/inner/balance/getUserBalance'
}

const URLS = {}
for (let k in urls) {
  const arr = urls[k].split(' ')
  URLS[k] = `${arr[0]} ${BASE}${arr[1]}`
}

export default URLS



// WEBPACK FOOTER //
// ./src/apis/api-urls/gporder-api.js